//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import { getSomeWxInfo } from '@/request/api'
export default {
  name: 'HelloWorld',
  data () {
    return {
      androidMessage: '',
      iosMessage: '',
      url: ''
    }
  },
  mounted () {
    // window.location.href = 'https://forms.ebdan.net/ls/L4xFqWjh?bt=yxy'
    this.getSomeWxInfo()
    window.getIosInfo = this.getIosInfo
    this.url = window.location.href
    this.getAndroidInfo()
  },
  created () {
    this.getIosInfo()

    wx.miniProgram.getEnv(function(res) {
      console.log('env', res)
      alert(`${JSON.stringify(res)}`)
    })
  },
  methods: {
    getSomeWxInfo () {
      getSomeWxInfo({}).then(res => {
        console.log('info:', res)
      })
    },

    H5ToGoodsDetail (key) {
      client_js.H5ToGoodsDetail(key)
    },

    getAndroidInfo () {
      const a = client_js.getAll()
      this.androidMessage = a
    },

    iosToGoodsDetail (key) {
      iosToGoodsDetail(key)
    },

    jumpToMiniprogram () {
      wx.miniProgram.redirectTo({
        url: '/pages/businessHomePage/index',
        //url: '/pages/content/content?id=1', 传参
      })
    },

    clickDidClick:function () {
      const params = {
        goods_id: '236',
        type: 1
      }
      //iOS可以监听到这个方法
      H5ToGoodsDetail(JSON.stringify(params))
    },

    getIosInfo (params) {
      this.iosMessage = JSON.parse(params).token
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.vue